<template>
  <div v-if="changeAddress != null">
    <section class="user_mail_change text_center">
      <h2 class="header_underline">メールアドレスの変更・登録</h2>

      <p class="user_mail_change_overview">アドレスの変更・登録がご希望の場合、<br>変更後・登録先のアドレスよりご連絡下さいます様お願い致します。</p>
      <p><a :href="`mailto:${changeAddress}?body=${mailBody}&amp;subject=${mailSubject}`" class="btn arrow">アドレス変更・登録希望</a></p>
      <p class="notice text_left user_mail_change_overview">
        イタズラ防止の為、ご登録希望の以前のアドレスにもメールを送信させて頂きます。<br>
        そのメールが届く状態の場合、アドレスの変更をする事は出来ませんので予めご容赦下さい。
      </p>
      <p><router-link :to="{ name: 'UserProfile' }" class="arrow link_main--text">プロフィール設定に戻る</router-link></p>
    </section>
  </div>
</template>

<script>
import { GET_USER_MAIL_CHANGE_ADDRESS } from '@/store/user/actions'

export default {
  name: 'UserMailChange',
  data () {
    return {
      changeAddress: null,
      mailSubject: 'メールアドレス変更',
      mailBody: 'このまま送信してください。'
    }
  },
  methods: {
    getMailChangeAddress () {
      this.$store.dispatch(GET_USER_MAIL_CHANGE_ADDRESS)
        .then((data) => {
          this.changeAddress = data.change_mail
        })
        .catch(() => {
          this.$router.pushIsses({ name: 'UserProfile' })
        })
    }
  },
  created () {
    this.getMailChangeAddress()
  }
}
</script>
